import React from 'react';
import { Button } from "../../components/ui/button";

const HelpRequestsTile = ({ issuesNumber }) => {  
  // Determine the severity class based on number of requests
  const getSeverityColor = () => {
    if (issuesNumber >= 3)
      return "bg-red-50 border-red-100 text-red-800";
    if (issuesNumber === 1 || issuesNumber === 2)
      return "bg-yellow-50 border-yellow-100 text-yellow-800";
    return "bg-green-50 border-green-100 text-green-800";
  };

  return (
    <div className={`w-full p-4 mb-4 border rounded-lg ${getSeverityColor()}`}>
      <div className="flex justify-between items-center">
        <div className="flex flex-col">
          <h2 className="text-lg font-bold">Escalated Issues</h2>
          <div className="flex items-center gap-1">
            <span className="text-3xl font-bold">{issuesNumber}</span>
            <span>Requests need attention</span>
          </div>
        </div>
        <Button asChild className="px-4 bg-red-600 hover:bg-red-700 text-white">
          <a href="/admin/issues?tab=reported">
            View Requests
            <span className="ml-1">→</span>
          </a>
        </Button>
      </div>
    </div>
  );
};

export default HelpRequestsTile;
